import React from "react";
import { Select, Tag } from "antd";
import type { SelectProps } from "antd";

export interface ModelSelectOption {
  label: string;
  value: string;
  isDefault?: boolean;
  supportsToolCalls?: boolean;
  supportsImage?: boolean;
}

interface ModelSelectProps extends Omit<SelectProps, "options"> {
  models: ModelSelectOption[];
  requireTools?: boolean;
  requireVision?: boolean;
}

const ModelSelect: React.FC<ModelSelectProps> = ({ models, requireTools, requireVision, ...props }) => {
  const options = models
    .filter((model) => !requireTools || model.supportsToolCalls)
    .filter((model) => !requireVision || model.supportsImage)
    .map((model) => ({
      value: model.value,
      label: (
        <span>
          {model.label}
          {model.isDefault && <Tag style={{ marginLeft: 8 }}>默认</Tag>}
          {model.supportsToolCalls && <Tag color="blue">Tools</Tag>}
          {model.supportsImage && <Tag color="purple">Vision</Tag>}
        </span>
      ),
    }));

  return <Select allowClear showSearch optionFilterProp="label" options={options} {...props} />;
};

export default ModelSelect;
